<button *ngIf="isIFrame"
        (click)="openAppInNewTab()"
        mat-icon-button
        aria-label="Weiterleitung zur Web-Applikation"
        class="iframe-button mdc-fab-mini">
    <mat-icon>open_in_new</mat-icon>
    <span class="text-on-hover">{{'floating_button.info' | translate}}</span>
</button>